import u from './Utilities';

export default class API {
    static ENDPOINTROOT = process.env.REACT_APP_API_WP_ENDPOINT_URL;

    static headers = {
        'X-WP-Nonce': this.getWPNonce()
    };

    constructor() {

    }

    // WordPress
    static getWPNonce() {
        return window.localStorage.getItem('hwnonce') ?? null;
    }

    static getState() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/state' + '?cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null,
                headers: this.headers,
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getProjectMap() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/project-map' + '?cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null,
                headers: this.headers,
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getCredits(parameters = {}) {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/credits/add', {
                method: 'POST',
                credentials: "include",
                body: null
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getVouchers(parameters = {}) {
        return new Promise((resolve, reject) => {
            fetch(u.querify(this.ENDPOINTROOT + '/vouchers', [
                ['uid', parameters.userID],
            ]), {
                method: 'POST',
                credentials: "include",
                body: null
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static postBooking(parameters = {}) {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/book' + '?cb=' + u.genString(10), {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'name': parameters.name,
                    'email': parameters.email,
                    'start': parameters.start,
                    'end': parameters.end,
                    'resource_id': parameters.resourceID,
                    'project_id': parameters.projectID,
                    'user_id': parameters.userID,
                    'use': parameters.use,
                    'guest_count': parameters.guestCount,
                    'test_mode': parameters.testMode
                })
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static postBookingCheck(parameters = {}) {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/book/check' + '?cb=' + u.genString(10), {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'name': parameters.name,
                    'email': parameters.email,
                    'start': parameters.start,
                    'end': parameters.end,
                    'resource_id': parameters.resourceID,
                    'project_id': parameters.projectID,
                    'user_id': parameters.userID
                })
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    // Timekit
    static getTimekitResources() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/tk/resources' + '?cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
    
    static getTest() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/test?action=booking_test' + '&cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null,
                headers: this.headers,
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getTimekitBookings() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/tk/bookings' + '?cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null,
                headers: this.headers,
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
    
    static getTimekitProjects() {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/tk/projects' + '?cb=' + u.genString(10), {
                method: 'GET',
                credentials: "include",
                body: null
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getTimekitProjectResources(parameters) {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/tk/projects/resources', {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type' : 'application/json'
                },
                body: JSON.stringify({
                    id: parameters.id
                })
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    static getTimekitAvailability(parameters = {}) {
        return new Promise((resolve, reject) => {
            fetch(this.ENDPOINTROOT + '/tk/availability' + '?cb=' + u.genString(10), {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    project_id: parameters.projectID,
                    resource_id: parameters.resourceID
                })
            }).then(res => res.json()).then(
                (success) => {
                    resolve(success);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
}